import React, { useEffect, useState } from 'react'
import PackBoxesTable from './PackBoxesTable'
import { getPackBoxesAPI } from '../../../api/pack/boxAPI'

const PackBoxesList = ({ packId }) => {

    const [count, setCount] = useState(0)
    const [limit, setLimit] = useState(10)
    const [offset, setOffset] = useState(0)
    const [query, setQuery] = useState('')

    const [boxes, setBoxes] = useState([])

    useEffect(() => {
        getPackBoxesAPI({ packId, offset, limit, query }).then(data => {
            setCount(data.count)
            setBoxes(data.boxes)
        }).catch(e => {
            
        })
    }, [packId, limit, offset, query])

  return (
    <div>
        <PackBoxesTable
            packId={packId}
            boxes={boxes}
            count={count}
            limit={limit}
            setLimit={setLimit}
            offset={offset}
            setOffset={setOffset}
        />
    </div>
  )
}

export default PackBoxesList